import { render, staticRenderFns } from "./CustomTabsSort.vue?vue&type=template&id=5ff055f2&scoped=true&"
import script from "./CustomTabsSort.vue?vue&type=script&lang=js&"
export * from "./CustomTabsSort.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabsSort.vue?vue&type=style&index=0&id=5ff055f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff055f2",
  null
  
)

export default component.exports